import { Link } from "react-router-dom"
import {ArrowRight, Shield, Clock, CheckCircle} from 'lucide-react'

interface CTASectionProps {
  title?: string
  subtitle?: string
  buttonText?: string
  buttonLink?: string
}

export default function CTASection({
  title = "Ready to Finance Your Restaurant?",
  subtitle = "Use our precision calculators to estimate your monthly payments, then connect with lenders who specialize in restaurant and franchise financing.",
  buttonText = "Check Your Eligibility",
  buttonLink = "/#calculator",
}: CTASectionProps) {
  return (
    <section className="py-16 sm:py-20">
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-emerald-600 to-emerald-800 p-8 sm:p-12">
        {/* Background decoration */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-black/10 rounded-full translate-y-1/2 -translate-x-1/2" />

        <div className="relative z-10 text-center max-w-2xl mx-auto">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4">{title}</h2>
          <p className="text-emerald-100/80 text-sm sm:text-base mb-8 leading-relaxed">{subtitle}</p>

          <Link
            to={buttonLink}
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-emerald-700 font-bold text-sm rounded-xl hover:bg-emerald-50 transition-all duration-200 shadow-xl shadow-black/20"
          >
            {buttonText}
            <ArrowRight className="w-4 h-4" />
          </Link>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-8">
            <div className="flex items-center gap-2 text-emerald-100/70 text-xs">
              <Shield className="w-4 h-4" />
              <span>No Credit Impact</span>
            </div>
            <div className="flex items-center gap-2 text-emerald-100/70 text-xs">
              <Clock className="w-4 h-4" />
              <span>2-Minute Estimate</span>
            </div>
            <div className="flex items-center gap-2 text-emerald-100/70 text-xs">
              <CheckCircle className="w-4 h-4" />
              <span>100% Free Tool</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
